export default __webpack_public_path__ + "static/media/404-error-page-not-found.15ea9776.jpg";